import { Box, IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import editIcon from 'packages/novous_web/src/assets/icons/edit.svg';
import deleteIcon from 'packages/novous_web/src/assets/icons/delete1.svg';
import ViewIcon from 'packages/novous_web/src/assets/icons/Eye.svg';
import { useState } from 'react';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Button from 'packages/novous_web/src/common/components/Button';

const OrderDetailsTable = ({ formData, isSummaryView, onEdit, onDelete, onUpdateVehicles }: { formData: any, isSummaryView: boolean, onEdit: (data: any, index: number) => void, onDelete: (index: number) => void, onUpdateVehicles: (orderIndex: number, updatedVehicles: string[]) => void }) => {
    if (!formData) return null;
    const theme = useTheme();
    const tableHeaderBg = theme.palette.mode === "dark" ? "#2D2D2D" : "#F0EFF8";
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any>(null);

    const handleView = (order: any) => {
        setSelectedOrder(order);
        setViewModalOpen(true);
    };

    const closeModal = () => {
        setViewModalOpen(false);
        setSelectedOrder(null);
    };

    const formatDuration = (totalSeconds: number): string => {
        const secondsInMinute = 60;
        const secondsInHour = 60 * secondsInMinute;
        const secondsInDay = 24 * secondsInHour;
        const secondsInMonth = 30 * secondsInDay;
        const secondsInYear = 12 * secondsInMonth;

        const years = Math.floor(totalSeconds / secondsInYear);
        totalSeconds %= secondsInYear;

        const months = Math.floor(totalSeconds / secondsInMonth);
        totalSeconds %= secondsInMonth;

        const days = Math.floor(totalSeconds / secondsInDay);
        totalSeconds %= secondsInDay;

        const hours = Math.floor(totalSeconds / secondsInHour);
        totalSeconds %= secondsInHour;

        const minutes = Math.floor(totalSeconds / secondsInMinute);
        const seconds = totalSeconds % secondsInMinute;

        const parts = [];
        if (years) parts.push(`${years} Years`);
        if (months) parts.push(`${months} Months`);
        if (days) parts.push(`${days} Days`);
        if (hours) parts.push(`${hours} Hours`);
        if (minutes) parts.push(`${minutes} Min`);
        if (seconds) parts.push(`${seconds} Sec`);

        return parts.join(' ');
    };


    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: "50vh" }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: tableHeaderBg }}>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Order Summary
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Duration
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                User Name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Start Date
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Order Quantity
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Devices
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Price
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {formData.map((order: any, index: number) => (
                            <TableRow key={index}>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.item}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {formatDuration(order.duration)}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.userName}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.startDate}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.quantity}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.selectedDevice?.[0]}
                                    {order.selectedDevice?.length > 1 && (
                                        <> +{order.selectedDevice.length - 1} more</>
                                    )}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                    {order.price}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 400, fontSize: "14px", display: "flex", gap: 2 }}>
                                    <IconButton onClick={() => handleView(order)}>
                                        <img src={ViewIcon} alt="View" />
                                    </IconButton>
                                    {!isSummaryView && (
                                        <>
                                            <IconButton onClick={() => onEdit(order, index)}>
                                                <img src={editIcon} alt="Edit" />
                                            </IconButton>
                                            <IconButton onClick={() => onDelete(index)}>
                                                <img src={deleteIcon} alt="Delete" />
                                            </IconButton>
                                        </>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Modal open={viewModalOpen} onClose={closeModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 540,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h6" mb={2}>Item Details</Typography>
                    {selectedOrder && (
                        <Box className="flex flex-col gap-4">
                            <Box className="grid grid-cols-2 gap-4">
                                <Box className="flex flex-col gap-2">
                                    <Typography variant="body2" fontWeight={400} fontSize={16}>Selected Item</Typography>
                                    <Typography variant="body2" fontWeight={600} fontSize={16}>{selectedOrder.item}</Typography>
                                </Box>
                                <Box className="flex flex-col gap-2">
                                    <Typography variant="body2" fontWeight={400} fontSize={16}>Duration</Typography>
                                    <Typography variant="body2" fontWeight={600} fontSize={16}>{formatDuration(selectedOrder.duration)}</Typography>
                                </Box>
                            </Box>
                            <Box className="grid grid-cols-3 gap-4">
                                <Box className="flex flex-col gap-2">
                                    <Typography variant="body2" fontWeight={400} fontSize={16}>Start Date</Typography>
                                    <Typography variant="body2" fontWeight={600} fontSize={16}>{selectedOrder.startDate}</Typography>
                                </Box>
                                <Box className="flex flex-col gap-2">
                                    <Typography variant="body2" fontWeight={400} fontSize={16}>Quantity</Typography>
                                    <Typography variant="body2" fontWeight={600} fontSize={16}>{selectedOrder.quantity}</Typography>
                                </Box>
                                <Box className="flex flex-col gap-2">
                                    <Typography variant="body2" fontWeight={400} fontSize={16}>Price (in INR)</Typography>
                                    <Typography variant="body2" fontWeight={600} fontSize={16}>{selectedOrder.price}</Typography>
                                </Box>
                            </Box>
                            <Box className="flex flex-col gap-1 col-span-2">
                                <Typography variant="body2" fontWeight={400} fontSize={16}>Selected Devices</Typography>
                                <Box className="flex flex-col gap-2">
                                    {selectedOrder.selectedDevice.map((vehicle: string, index: number) => (
                                        <Box key={index} className="flex items-center justify-between gap-2">
                                            <Typography variant="body2" fontWeight={600} fontSize={16}>{vehicle}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    )}
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <CustomIconButton
                            text="Done"
                            onClick={() => setViewModalOpen(false)}
                            variant='contained'
                        />
                    </Box>
                </Box>
            </Modal>
        </>

    )
}

export default OrderDetailsTable